import { useEffect } from 'react';

import { AsyncThunk } from '@reduxjs/toolkit';

import { useAppDispatch } from '../../../store/hooks';

export const useGetTableEntries = <TFeatureFilters>(
  headerFilters: Partial<TFeatureFilters>,
  dispatchFn: AsyncThunk<
    number,
    Partial<TFeatureFilters> | undefined,
    Record<string, unknown>
  >,
  activeMandantId?: number | null
): void => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (activeMandantId !== null) {
      dispatch(dispatchFn(headerFilters));
    }
  }, [headerFilters, activeMandantId]);
};
